import { Component, Inject, ViewChild, TemplateRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NativeDateAdapter } from '@angular/material/core';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from '@app/core/services/AuthenticationService'
import { IDeduction } from '@app/core/interfaces/invoice/IDeduction';
import { IFile } from '@app/core/interfaces/IFile';
import { ITimeReportStatus } from '@app/core/interfaces/invoice/TimeReportStatus';
import { InvoiceService } from '@app/core/services/InvoiceService';
import { CompanyService } from '@app/core/services/CompanyService';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UserService } from '@app/core/services/UserService';
import { FileService } from '@app/core/services/FileService';


@Component({
  standalone: false,
    selector: 'edit-deduction-dialog',
    templateUrl: 'edit-deduction-Dialog.Component.html',
    styleUrls: ['edit-deduction-Dialog.Component.scss']
})

export class EditDeductionDialogComponent {
    private _dimesionToggle = false;
    private _formValid = false;
    public _imageList: any[] = [];
    public _hasImages = false;
    private _showImageList = false;
    private _showAttachments = false;
    private _hasAttachments = false;
    private _showComments = false;
    //public customer: ICompany;
    public isNewCustomer: boolean;
    @ViewChild('myInput', { static: false })
    myInputVariable: any;
    private _apiBaseUrl: string;
    @ViewChild("datepicker", { static: false }) datepicker: MatDatepicker<Date>;
    selectedDate: Date = new Date();
    private hoursList = [];
    private minutesList = [];
    public rowTypeList = [];
    private hoursSelected: string = "8";
    private minutesSelected: string = "0";
    private rowTypeSelected: string = "0"
    private row: any = {};
    private selectedDates = [];
    TravelExpense = true;
    HealthCare = true;
    HealthCareAmountThisYear: number = 0;
    fileSizeErrorAttachment: string = '';
    fileSizeErrorReceipt: string = '';
    public isInvoiceCurrencySek: boolean = true;
    private agreedInvoiceAmountWasManuallyEdited: boolean = false;


    vatList = [{ Value: "25" }, { Value: "12" }, { Value: "6" }, { Value: "0" }];
    //private timeReportStatuses: Array<ITimeReportStatus> = [];


    deduction: IDeduction = <IDeduction>{};

    constructor(
        public dialogRef: MatDialogRef<EditDeductionDialogComponent>,
        private fileService: FileService,
        //
        //private authenticationService: AuthenticationService,
        private invoiceService: InvoiceService,
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) 
    { 
        
    }

    ngOnInit() {

      this.deduction = JSON.parse(JSON.stringify(this.data.deduction));
      this.TravelExpense = this.deduction.TravelExpense;
      this.HealthCare = this.deduction.HealthCare;

      if (this.deduction.AddedToInvoice && (this.deduction.AgreedInvoiceAmount === null || this.deduction.AgreedInvoiceAmount === undefined)) {
        this.deduction.AgreedInvoiceAmount = this.deduction.Amount;
      }
      this.agreedInvoiceAmountWasManuallyEdited = this.deduction.AgreedInvoiceAmount != null
        && this.deduction.AgreedInvoiceAmount !== this.deduction.Amount;

      var invoiceCurrencyName = this.getInvoiceCurrencyName();
      this.isInvoiceCurrencySek = invoiceCurrencyName ? invoiceCurrencyName.toUpperCase() === 'SEK' : true;

      if (!this.isInvoiceCurrencySek) {
        this.deduction.AddedToInvoice = false;
      }

      if (this.HealthCare) { debugger
        if (this.data && this.data.userId) {
          this.getHealthCareAmountThisYear(this.data.userId);
        }
      }

      console.log("Data")
      console.log(this.data);
    }

    onSubmit()
    {
        this.save();
    }
    
    canEditGroup()
    {
        let statuses = ["Draft"];
        return statuses.includes(this.data.status);
    }

    getTimeReportStatuses()
    {
        //this.invoiceService.getTimeReportStatuses()
        //    .subscribe(
        //    response => this.getTimeReportStatusesFinished(response),
        //    error => console.log(error));
    }

    deleteFile(file: IFile)
    {
        file.Guid = null;
        file.Id = 0;
    }

    showFile(file: IFile) {
        this.fileService.openFile(file);
    }

    rowTypeChange(event: any)
    {
        this.data.invoiceItemGroup.Type = this.getRowType(event.value);
        
        if (event.value == "Övrigt")
        {
            // No rows allowed in the misc category
            this.data.invoiceItemGroup.InvoiceRows = [];
        }
    }

    getRowType(id: any)
    {
        for (var i = 0; i < this.rowTypeList.length; i++)
        {
            if (this.rowTypeList[i].Name == id)
            {
                return { Id: this.rowTypeList[i].Id, Name: this.rowTypeList[i].Name};
            }
        }
    }

    save()
    {
        this.dialogRef.close(this.deduction);
    }

    onAddedToInvoiceChange(added: boolean) {
        if (!this.isInvoiceCurrencySek) {
            this.deduction.AddedToInvoice = false;
            return;
        }

        this.deduction.AddedToInvoice = added;

        if (added && (this.deduction.AgreedInvoiceAmount === null || this.deduction.AgreedInvoiceAmount === undefined)) {
          this.deduction.AgreedInvoiceAmount = this.deduction.Amount;
          this.agreedInvoiceAmountWasManuallyEdited = false;
        }
    }

    onReceiptAmountChange(amount: number | null) {
      const previousReceiptAmount = this.deduction.Amount;
      this.deduction.Amount = amount;

      if (this.deduction.AddedToInvoice
        && (!this.agreedInvoiceAmountWasManuallyEdited || this.deduction.AgreedInvoiceAmount === previousReceiptAmount)) {
        this.deduction.AgreedInvoiceAmount = amount;
      }
    }

    onAgreedInvoiceAmountChange(amount: number | null) {
      this.deduction.AgreedInvoiceAmount = amount;
      this.agreedInvoiceAmountWasManuallyEdited = amount !== this.deduction.Amount;
    }

    private getInvoiceCurrencyName(): string | null {
        if (this.data && this.data.invoiceCurrencyName) {
            return this.data.invoiceCurrencyName;
        }

        if (this.data && this.data.currencyName) {
            return this.data.currencyName;
        }

        if (this.data && this.data.currency && this.data.currency.Name) {
            return this.data.currency.Name;
        }

        return null;
    }
    
    cancel()
    {
        this.dialogRef.close(null);
    }
    
    deleteRow()
    {
        this.data.invoiceItemGroup.action = 'delete';
        this.dialogRef.close(this.data.invoiceItemGroup);
    }    

    
    deleteListItem(item: any)
    {
        console.log(item);

        this.data.invoiceItemGroup.InvoiceRows.splice(this.data.invoiceItemGroup.InvoiceRows.indexOf(item), 1);
    }

    guid() {  
        return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
  }

  changeValue(value, type) {


    if (type == 'travel') { debugger
      this.TravelExpense = value.checked;
      this.deduction.TravelExpense = this.TravelExpense;
      if (this.TravelExpense) {
        this.deduction.HealthCare = false;
        this.HealthCare = false;
      }
    }
    if (type == 'health') { 
      this.HealthCare = value.checked;
      this.deduction.HealthCare = this.HealthCare;
      if (this.HealthCare) {
        this.deduction.TravelExpense = false;
        this.TravelExpense = false;
      }
      debugger
      if (this.data && this.data.userId) {
        this.getHealthCareAmountThisYear(this.data.userId);
      } else {
        console.warn('Missing userId in dialog data; skipping health care amount lookup.');
      }
      
    }
  }

  getHealthCareAmountThisYear(userId: string) {  
    this.userService.getTotalAmountOfHealthCareDeduction(userId)
      .subscribe(
        response => this.onHealthCareAmountReceived(response),
        error => console.log(error));
  }

  onHealthCareAmountReceived(response: any) { debugger
    this.HealthCareAmountThisYear = response;

  }

    
    calendarSelect(event: any)
    {
        var date = event.toLocaleDateString('sv-SE');

        // Duplicate dates not allowed
        for (var i = 0; i < this.data.invoiceItemGroup.InvoiceRows.length; i++)
        {
            var item = this.data.invoiceItemGroup.InvoiceRows[i];

            if (item.StartDate == date)
            {
                return;
            }
        }

        // Add item
        this.data.invoiceItemGroup.InvoiceRows.push({ StartDate: date, Id: this.guid(), HoursWorked: this.hoursSelected, MinutesWorked: this.minutesSelected });

        // Sort list by date
        this.data.invoiceItemGroup.InvoiceRows.sort((val1: any, val2: any) => {
            var d1 = <any>new Date(val1.StartDate.toString());
            var d2 = <any>new Date(val2.StartDate.toString());
            
            return d1 - d2;
        })
        
    }
    
    onError(error: any)
    {
        alert('An error occured');
        console.log(error);
    }

    fileChange(event: any, file: IFile) {

      var fileType = "";

      if (this.TravelExpense) {
        fileType = "AllowanceReceipt";
      }
      else {
        fileType = 'DeductionReceipt';
      }

      // Reset only the error state for the current input
      const isReceipt = file === this.deduction.AttachmentReciept;
      if (isReceipt) { this.fileSizeErrorReceipt = ''; } else { this.fileSizeErrorAttachment = ''; }

      let fileList: FileList = event.target.files;
      if (fileList.length > 0) {
        let f: File = fileList[0];

        if (!/\.(pdf|jpe?g|png|gif)$/i.test(f.name)) {
          this.invoiceService.showMessage("Endast PDF och bilder i JPG-, PNG- eller GIF-format är tillåtna.");
          event.target.value = '';
          return;
        }

        // Validate file size: max 5 MB
        if (f.size > 5 * 1024 * 1024) {
          if (isReceipt) { this.fileSizeErrorReceipt = 'Filen får vara högst 5Mb'; } else { this.fileSizeErrorAttachment = 'Filen får vara högst 5Mb'; }
          // Clear the file input so UI stays in upload state
          if (event && event.target) { try { event.target.value = ''; } catch { /* ignore */ } }
          return;
        }

        // Validate zero-byte file
        if (f.size === 0) {
          if (isReceipt) { this.fileSizeErrorReceipt = 'Filen verkar vara tom (0 bytes).'; } else { this.fileSizeErrorAttachment = 'Filen verkar vara tom (0 bytes).'; }
          if (event && event.target) { try { event.target.value = ''; } catch { /* ignore */ } }
          return;
        }
        if (!file.Guid) { file.Guid = this.newGuid(); }
        file.Name = f.name;

        this.invoiceService.uploadDocument(f, file.Guid, fileType)
          .subscribe(
            response => this.onDocumentSaved(response, file),
            error => console.log(error));

      }
    }

    newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    onDocumentSaved(response: any, file: IFile)
    {
        file.Id = response.Id;
        file.Url = response.Url;
        file.FileType = response.FileType;
        file.Guid = response.Guid;
        file.Name = response.Name || file.Name;
        if ((response as any).FileSize !== undefined) {
          file.FileSize = (response as any).FileSize;
          if (file.FileSize === 0) {
            const isReceipt = file === this.deduction.AttachmentReciept;
            if (isReceipt) { this.fileSizeErrorReceipt = 'Filen verkar vara tom (0 bytes).'; } else { this.fileSizeErrorAttachment = 'Filen verkar vara tom (0 bytes).'; }
          }
        }

    }

    getMissingRequirementMessage(form: NgForm): string | null {
      if (!form) {
        return null;
      }

      // Top-to-bottom order as displayed in the dialog
      if (this.deduction?.AddedToInvoice && form.controls['name'] && form.controls['name'].invalid) {
        return 'Fyll i "Text på kundfakturan".';
      }

      if (form.controls['message'] && form.controls['message'].invalid) {
        return 'Fyll i "Beskrivning/syfte".';
      }

      if (form.controls['amount'] && form.controls['amount'].invalid) {
        return 'Fyll i "Belopp (SEK)".';
      }

      if (!this.deduction?.Attachment?.Guid) {
        return 'Ladda upp dokument.';
      }

      return null;
    }


    
}



